"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingList = void 0;
const react_1 = __importStar(require("react"));
const sorting_list_constants_1 = require("./sorting-list.constants");
const sorting_list_styles_1 = require("./sorting-list.styles");
const localization_1 = require("../../../../localization");
const SortingList = ({ selectedOption, onSelectOption, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const options = (0, react_1.useMemo)(() => sorting_list_constants_1.sortingListMenuItems.map(({ label, value }) => (react_1.default.createElement(sorting_list_styles_1.StyledMenuItem, { key: value, value: value }, t({ key: label })))), [t]);
    const handleSelectOption = (e) => onSelectOption(e.target.value);
    return (react_1.default.createElement(sorting_list_styles_1.StyledSortingList, { value: selectedOption !== null && selectedOption !== void 0 ? selectedOption : '', size: "small", onChange: handleSelectOption, variant: "outlined" }, options));
};
exports.SortingList = SortingList;
exports.default = exports.SortingList;
